export const FILESTATUS = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    SETTLED: 'SETTLED',
    PAID: 'PAID',
    DECLINED: 'DECLINED',

};